import styled from "styled-components";

export const CommentFloatMessage = styled.div`
  position: fixed;
  display: grid;
  width: calc(100vw - 32px);
  height: 70px;
  left: 16px;
  bottom: 86px;
  padding: 10px;
  -webkit-backgrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  background: ${(props) => props.theme.colors.white60};
  border-radius: 35px;
  box-shadow: ${(props) => props.theme.shadows.floatComment};
  align-items: center;
  grid-template-columns: calc(100vw - 92px) 40px;

  &:active {
    background: ${(props) => props.theme.colors.primary5};
  }
`;

export const MessageInfoBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

export const GuardianImg = styled.div`
  overflow: hidden;
  width: 50px;
  height: 50px;
  background: ${(props) => props.theme.colors.primary5};
  border: 1px solid ${(props) => props.theme.colors.primary5};
  border-radius: 50%;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 10px;
  }
`;

export const MessageTit = styled.div`
  overflow: hidden;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.1rem;
    font-weight: 700;
  }

  div {
    overflow: hidden;
    color: ${(props) => props.theme.colors.text4};
    font-size: 1.4rem;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
